import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturedServices from '../components/home/FeaturedServices';
import Testimonials from '../components/home/Testimonials';
import BookingCTA from '../components/home/BookingCTA';

const HomePage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <FeaturedServices />
      <Testimonials />
      <BookingCTA />
    </>
  );
};

export default HomePage;
